import { ApplicationConfig, provideAppInitializer } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { provideRouter } from '@angular/router';
import { Ct2Config, CtBatchApiService } from '@ps-gui/claims-terminal-shared';
import {
  AuthenticationService,
  initializeKeyStates,
  KeycloakAuthenticationService,
  provideConfigFromUri,
  providePrimeNg,
} from '@ps-gui/shared-core';
import { appRoutes } from './app.routes';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: AuthenticationService,
      useClass: KeycloakAuthenticationService,
    },
    MessageService,
    ConfirmationService,
    CtBatchApiService,
    provideHttpClient(withFetch(), withInterceptors([includeBearerTokenInterceptor])),
    provideAppInitializer(() => initializeKeyStates()),
    provideConfigFromUri<Ct2Config>('./assets/config/config.json'),
    environment.provideKeycloak(),
    provideRouter(appRoutes),
    providePrimeNg(),
    {
      provide: DialogService,
      useClass: DialogService,
    },
  ],
};
